<template>
  <div class="not-found">
    <div class="not-found-code">404</div>
    <div class="not-found-text">抱歉，您访问的页面不存在</div>
    <a-button type="primary" @click="$router.push('/')">返回首页</a-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;

  .not-found-code {
    font-size: 120px;
    font-weight: 700;
    color: #1677ff;
    line-height: 1;
    margin-bottom: 16px;
    letter-spacing: -4px;
  }

  .not-found-text {
    font-size: 16px;
    color: #666;
    margin-bottom: 32px;
  }
}
</style>
